module.exports = __webpack_public_path__ + "img/qiancai-back-phone@2x.e2b6aeab.png";